export default __webpack_public_path__ + "static/media/blueBag.eceb47f0.jpg";